import React from 'react';
import LoopyAvatar, { LoopyState, LoopyEmotion, LoopySize } from './LoopyAvatar';
import './LoopyBubble.css';

interface LoopyBubbleProps {
  state?: LoopyState;
  emotion?: LoopyEmotion;
  avatarSize?: LoopySize;
  title?: string;
  message?: React.ReactNode;
  children?: React.ReactNode;
  className?: string;
}

const LoopyBubble: React.FC<LoopyBubbleProps> = ({
  state = 'hint',
  emotion = 'default',
  avatarSize = 'sm',
  title,
  message,
  children,
  className = '',
}) => {
  return (
    <div className={`loopy-bubble loopy-bubble--${state} ${className}`.trim()} role="status">
      <LoopyAvatar size={avatarSize} state={state} emotion={emotion} showBadge ariaLabel={title ?? 'Loopy'} />
      <div className="loopy-bubble__body">
        {title && <p className="loopy-bubble__title">{title}</p>}
        {message && <p className="loopy-bubble__message">{message}</p>}
        {children}
      </div>
    </div>
  );
};

export default LoopyBubble;
